// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"51347381","239":"5fea0372","453":"f5484016","455":"024a83d3","900":"365384e7","977":"4e211955"}[chunkId] + ".chunk.js";
};